import { i18n } from "../../../boot/i18n";
import { store } from "../../../store";

import general from "./general";
import quote from "./quote";
import invoice from "./invoice";
import service from "./service";

export default {
  routes: [
    {
      path: "/c/:customerID",
      props: true,
      component: () => import("layouts/Main"),
      meta: {
        auth: ({ customerID }) =>
          store.getters.isLoggedIn() &&
          (store.getters.isEmployee() ||
            store.getters.isUser(customerID) ||
            store.getters.isCompanyEmployee(customerID)),
      },
      children: [
        ...general.routes,
        ...quote.routes,
        ...invoice.routes,
        ...service.routes,
      ],
    },
  ],

  dialogs: [
    ...general.dialogs,
    ...quote.dialogs,
    ...invoice.dialogs,
    ...service.dialogs,
  ],
};
